$( document ).ready(function() {
  $('.bt-popup').click(function() {
      $(this).next('.bd-popup').addClass('active');
    $('.ol-popup').addClass('active');
  });
  $('.ol-popup').click(function() {
    $(this).removeClass('active');
  $('.bd-popup').removeClass('active');
  });
  $('.close-popup').click(function() {
    $('.ol-popup').removeClass('active');
  $('.bd-popup').removeClass('active');
  });
});
$(document).ready(function(){
  this.$container = $('.instagram-block');
    this.settings = {
      accesstoken 		: this.$container.data('accesstoken'),
      limit 			: this.$container.data('limit'),
      target 			: this.$container.attr('id')
    }
    var $instagramSelector = $('#'+this.settings.target);
    var $at = this.settings.accesstoken;
    var $limit = this.settings.limit;
  $instagramSelector.each(function(){
    
    var feed = new Instafeed({
    accessToken: $at,
    limit: $limit,
    transform: function(item) {
      var d = new Date(item.timestamp);
      item.date = [d.getDate(), d.getMonth(), d.getYear()].join('/');
      return item;
    }
   });
  feed.run();
  });
});
$(".js-countdown").each(function() {
    var t = $(this).data("time");
    $(this).lofCountDown({
        TargetDate: t,
        DisplayFormat: "<ul class='list--inline'><li class='gradient-theme-vertical'><span class='countdown-time'>%%D%%</span><span class='countdown-text'>Days</span></li><li class='gradient-theme-vertical'><span class='countdown-time'>%%H%%</span><span class='countdown-text'>Hours</span></li><li class='gradient-theme-vertical'><span class='countdown-time'>%%M%%</span><span class='countdown-text'>Mins</span></li><li class='gradient-theme-vertical'><span class='countdown-time'>%%S%%</span><span class='countdown-text'>Secs</span></li></ul>",
        FinishMessage: '<span class="alert alert-warning d-inline-block">' + "EXPIRED</span>"
    })
})
 




